export enum MacroButtonType {
  WidgetList,
  FormControl
}